import { ReactNode, useState } from 'react'
import EnergyIcon from '../../assets/energy.svg'
import styles from './Cards.module.css'

export interface SuggestedQuestion {
  agent: string
  question: string
  icon: ReactNode
}

interface SuggestedQuestionsCardProps {
  question: SuggestedQuestion
  onClick: (question: string) => void
  disabled?: boolean
}

export const SuggestedQuestionsCard = ({ question, onClick }: SuggestedQuestionsCardProps) => {
  return (
    <div className={`${styles.cardBase} ${styles.suggestedQuestionsCard}`}>
      <div className={styles.suggestedQuestionsIcon}>
        {question.icon}
      </div>
      <span className={styles.question}>{question.question}</span>
      <div className={styles.askTextContainer}>
        <span
          className={styles.askText}
          onClick={() => onClick(question.question)}
          aria-label="Ask this question">
          Ask this
        </span>
        <img
          src={EnergyIcon}
          alt="ask this icon"
        />
      </div>
    </div>
  )
}

export const SuggestionCard = ({
  question,
  onClick,
  disabled = false,
}: SuggestedQuestionsCardProps) => {
  const [isPressed, setIsPressed] = useState(false)

  const handleMouseDown = () => {
    if (!disabled) {
      setIsPressed(true)
    }
  }

  const handleMouseUp = () => {
    setIsPressed(false)
  }

  const handleMouseLeave = () => {
    setIsPressed(false)
  }

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick(question.question)
    }
  }

  const getCardClassName = () => {
    const classes = [styles.cardBase, styles.suggestionCard]

    if (disabled) {
      classes.push(styles.disabled)
    } else if (isPressed) {
      classes.push(styles.pressed)
    }

    return classes.join(' ')
  }

  return (
    <div
      className={getCardClassName()}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
    >
      <span className={isPressed ? styles.pressedIconWrapper : styles.iconWrapper}>
        {question.icon}
      </span>
      <span className={styles.text}>{question.question}</span>
    </div>
  )
}

